export default __webpack_public_path__ + "static/media/6.a5a302d0.jpg";